function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const fetchProductDetails = async (productId) => {
    const storefrontAccessToken = window.adminToken;
    try {
      const response = await fetch(
        `https://${Shopify.shop}/admin/api/2024-04/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Access-Token": storefrontAccessToken,
          },
          body: JSON.stringify({
            query: `{
                      node(id: "${productId}") {
                          ... on Product {
                              title
                              handle
                              metafield(namespace: "custom", key: "discontinued") {
                                  value
                                  type
                              }
                              images(first: 2) {
                                  edges {
                                      node {
                                          src
                                          altText
                                      }
                                  }
                              }
                              variants(first: 50) {
                                  edges {
                                      node {
                                          id
                                          title
                                          inventoryPolicy
                                          inventoryQuantity
                                          selectedOptions {
                                              name
                                              value
                                          }
                                          image {
                                              src
                                              altText
                                          }
                                      }
                                  }
                              }
                          }
                      }
                  }`,
          }),
        }
      );
      const data = await response.json();
      if (data && data.data && data.data.node) {
        return data.data.node;
      } else {
        return "";
      }
    } catch (error) {
      console.log("Error fetching product:", error);
      throw error;
    }
  };

  const processProductDetails = async (
    product,
    keyArray,
    valArray,
    featuredImageId,
    productDataElements,
    productId,
    primaryImagesrc,
    secondaryImagesrc,
    mainHandle,
    uniqueColors,
    counter
  ) => {
    if (product && product.variants && product.variants.edges) {
      for (const edge of product.variants.edges) {
        const variant = edge.node;
        if (variant  && variant.inventoryQuantity > 0) {
          for (const option of variant.selectedOptions) {
            if (
              option.name.toLowerCase() === "color" ||
              option.name.toLowerCase() === "colour" ||
              option.name.toLowerCase() === "couleur"
            ) {
              const key = option.value;
              if (!uniqueColors.has(key) && counter.count < 6) {
                uniqueColors.set(key, option);
                if (option.value.length > 0) {
                  let swatchHtml = "";

                  let active = "";
                  let variantImage = "";
                  let variantUrl = "";
                  let srcset = "";
                  let variantId = parseInt(variant.id.split("/").pop());

                  if (variant) {
                    if (variantId === featuredImageId) {
                      active = "active";
                    }
                    if (primaryImagesrc) {
                      variantImage = primaryImagesrc;
                    }
                    variantUrl = `/products/${product.handle}?variant=${variantId}`;
                  }

                  const imageSizes = "{{ sizes }}".split(",");

                  if (variantImage) {
                    imageSizes.forEach((size) => {
                      const sizeArray = size.split("x");
                      const sizeX =
                        sizeArray[0] +
                        "x" +
                        (sizeArray[1] !== "0" ? sizeArray[1] : "");
                      srcset += `${variantImage.replace(
                        ".jpg",
                        `_${sizeX}.jpg`
                      )} ${sizeArray[0]}w, `;
                    });
                  }

                  let colorValue = key.toLowerCase().trim();
                  const customColorIndex = keyArray.indexOf(colorValue);
                  if (customColorIndex > -1) {
                    colorValue = valArray[customColorIndex];
                  }

                  let bgValue = false;
                  if (colorValue.includes(".")) {
                    bgValue = colorValue;
                    colorValue = "var(--bg-body)";
                  }

                  const shopDomain = window.location.hostname;
                  const bgImageUrl = bgValue
                    ? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');`
                    : "";
                  swatchHtml += `
                    <div class="product-card-swatch ${active}"
                   style="--option-color: ${colorValue}; ${bgImageUrl}" 
                    data-srcset-2="${secondaryImagesrc}" 
                    data-srcset="${variantImage}"
                    data-href="${variantUrl}"
                    >
                      <span class="visually-hidden">${key}</span>
                    </div>
                  `;

                  productDataElements.insertAdjacentHTML(
                    "beforeend",
                    swatchHtml
                  );
                  counter.count++;
                }
              }
            }
          }
          if (counter.count >= 6) break;
        }
      }
      if (uniqueColors.size > 5 && counter.count >= 5) {
        const moreButtonHtml = `<div class="morebtn"><a href="/products/${mainHandle}" intellisuggest="" ss-ps="">+ More</a></div>`;
        productDataElements.insertAdjacentHTML("beforeend", moreButtonHtml);
      }
    }
  };

/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {
  constructor() {
    this.container = document.getElementById("Facet-Drawer");
    let button = document.getElementById("Facets-Toggle");

    // Add functionality to buttons
    if (button) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle("open-cc");
        this.container.classList.toggle("active");
      });
    }
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );

    FacetFiltersForm.updateFilteredProducts(true);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
    document.body.addEventListener('click', function (e) {
      const target = e.target;
      if (target.classList.contains('swatch-btn')) {
        FacetFiltersForm.updateSwatchInfo(target);
      }
    });
    const onResize = debounce((event) => {
      let root = document.documentElement,
        header = document.querySelector(".header"),
        height = header.clientHeight;

      if (window.innerWidth <= 768) {
        root.style.setProperty("--header-height-mobile", height + "px");
      }
    }, 200);
    window.addEventListener("resize", onResize);
    window.dispatchEvent(new Event("resize"));
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static updateSwatchInfo(swatchEl) {
      let productCard = swatchEl.closest('.card-wrapper');
      productCard.querySelectorAll('.swatch-btn').forEach((btn) => btn.classList.remove('active'));
      swatchEl.classList.add('active');
      
      let newSrc = swatchEl.dataset.src;
      let newSrcset = swatchEl.dataset.srcset;
      let newSrcAlt = swatchEl.dataset.srcalt;
      let newSrcsetAlt = swatchEl.dataset.srcsetalt;
      let newUrl = swatchEl.dataset.url;
      let newPrice = swatchEl.dataset.price;
      let newPriceNum = swatchEl.dataset.priceNum;
      let newComparePrice = swatchEl.dataset.comparePrice;
      let card_image = productCard.querySelector('.product-primary-image');
      let card_image_secondary = productCard.querySelector('.product-secondary-image');
      let card_del = productCard.querySelector('.price > del');
      const isSale = newComparePrice !== newPriceNum;
      if (!!newUrl) {
          productCard.querySelectorAll('a').forEach(link => link.setAttribute('href', newUrl));
      }
      if (newSrc && card_image) {
          card_image.setAttribute('src', newSrc);
          card_image.setAttribute('srcset', newSrcset);
      }
      if (newSrcAlt && card_image_secondary) {
          card_image_secondary.setAttribute('src', newSrcAlt);
          card_image_secondary.setAttribute('srcset', newSrcsetAlt);
      }
      if (newPrice) {
          productCard.querySelector('.amount.amount-single').innerHTML = newPrice;
      }
      if (card_del) {
        card_del.style.display = isSale ? 'block' : 'none';
      }
  }
  static updateFilteredProducts(onLoad) {
    if (onLoad) {
      document.querySelectorAll('.swatch-btn.active').forEach(swatchEl => FacetFiltersForm.updateSwatchInfo(swatchEl));
    }
    const filters = FacetFiltersForm.getShopifyTaxonomyFilters();
      if (filters) {
        const filterInt = setInterval(() => {
          const isLoading = document.querySelector('#ProductGridContainer .collection').classList.contains('loading');
          if (!isLoading) {
            document.querySelectorAll('.product-swatches').forEach((swatchContainer) => {
                  let found = false;
                  swatchContainer.querySelectorAll('.swatch-btn').forEach((swatchBtn) => {
                    const color = swatchBtn.dataset.color;
                    const colorTaxonomy = window.colorAssoc[color];
                    const isValidColor = filters.includes(colorTaxonomy);
                    if (!found && isValidColor) {
                      const check = !onLoad || (onLoad && swatchBtn.classList.contains('active'));
                      if (check) {
                        found = true;
                        FacetFiltersForm.updateSwatchInfo(swatchBtn);
                      }
                    }
                  });
                });
                clearInterval(filterInt);
              }
          }, 500);
      }
  }
  static getShopifyTaxonomyFilters() {
      const params = new URLSearchParams(window.location.search);
      let filters = [];
      params.forEach((value, key) => {
          if (key == 'filter.v.t.shopify.color-pattern') {
              filters.push(value);
          }
      });
      return filters;
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName("thb-filter-count");
    const productGridContainer = document.getElementById("ProductGridContainer");
    if (productGridContainer) {
      const collectionElement = productGridContainer.querySelector(".collection");
    
      if (collectionElement) {
        collectionElement.classList.add("loading");
      }
    }


    for (var item of container) {
      item.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (typeof FacetRemove !== "undefined") {
      // customElements.define('facet-remove', FacetRemove);
    }
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          {
            html,
            url,
          },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    FacetFiltersForm.updateFilteredProducts(false);
    document.querySelectorAll('.swatch-btn.active').forEach(swatchEl => FacetFiltersForm.updateSwatchInfo(swatchEl));
  }

  static renderProductCount(html) {
    //const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    let count = "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    const countElement = doc.getElementById("ProductCount");
    if (countElement) {
      count = countElement.innerHTML;
    }
    const container = document.getElementsByClassName("thb-filter-count");

    for (var item of container) {
      item.innerHTML = count;
      item.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll( "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter" );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter( (element) => !matchesIndex(element) );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const jsFilter = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (jsFilter && element?.innerHTML) {
        jsFilter.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-filter-count"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      {
        searchParams,
      },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  /*static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }*/

  static getSections() {
    const productGrid = document.getElementById("product-grid");
  
    if (productGrid) {
      return [
        {
          section: productGrid.dataset.id,
        },
      ];
    }
  
    return []; // Return an empty array or handle the case when the element is not found
  }


  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData);
    document.getElementsByTagName("body")[0].classList.remove("open-cc");
    document.getElementById("Facet-Drawer").classList.remove("active");

    if (searchParams.get("filter.v.price.gte") === "0.00") {
      searchParams.delete("filter.v.price.gte");
    }
    if (document.querySelector(".price_slider")) {
      if (
        searchParams.get("filter.v.price.lte") ===
        parseFloat(document.querySelector(".price_slider").dataset.max).toFixed(
          2
        )
      ) {
        searchParams.delete("filter.v.price.lte");
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
    setTimeout(async () => {
      const productCards = document.querySelectorAll(".product-card-swatch");
  const productIds = Array.from(productCards).map(
    (card) => card.dataset.productId
  );

  for (const productId of productIds) {
    const settings = window[`settings_${productId}`];
    const color_settings = window[`settings`];

    const customColorsArray = color_settings.color_swatches.split(',').map(color => {
      const [key, value] = color.split(':').map(part => part.trim());
      return { key: key.toLowerCase(), value: value };
    });

    const keyArray = customColorsArray.map((color) => color.key);
    const valArray = customColorsArray.map((color) => color.value);
    const productDetails = await Promise.all(
      settings.product_gids.map(fetchProductDetails)
    );

    let uniqueColors = new Map();
    let counter = { count: 0 };

    for (const productDetail of productDetails) {
      if (
        productDetail &&
        (!productDetail.metafield || productDetail.metafield.value !== "true")
      ) {
        let primaryImagesrc = "";
        let secondaryImagesrc = "";
        if (
          productDetail &&
          productDetail.images &&
          productDetail.images.edges
        ) {
          const images = productDetail.images.edges.map((edge) => edge.node);
          images.forEach((image, index) => {
            if (index === 0) {
              primaryImagesrc = image.src;
            }
            if (index === 1) {
              secondaryImagesrc = image.src;
            }
          });
        }
        await processProductDetails(
          productDetail,
          keyArray,
          valArray,
          settings.featured_image_id,
          document.getElementById("swatch_section_" + productId),
          productId,
          primaryImagesrc,
          secondaryImagesrc,
          settings.custom_handle,
          uniqueColors,
          counter
        );
        if (counter.count >= 6) break;
      }
    }
  }

  document
    .querySelectorAll("product-card")
    .forEach((card) => card.enableSwatches());
    }, 4000);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("a").forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const form =
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define("facet-remove", FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector(".price_slider"),
      amounts = this.querySelector(".price_slider_amount"),
      args = {
        start: [
          parseFloat(slider.dataset.minValue || 0),
          parseFloat(slider.dataset.maxValue || slider.dataset.max),
        ],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          min: 0,
          max: parseFloat(slider.dataset.max),
        },
      },
      event = new CustomEvent("input"),
      form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on("update", function (values) {
      amounts.querySelector(".field__input_min").value = values[0];
      amounts.querySelector(".field__input_max").value = values[1];
    });
    slider.noUiSlider.on("change", function (values) {
      form.querySelector("form").dispatchEvent(event);
    });
  }
}
customElements.define("price-slider", PriceSlider);

window.addEventListener("load", () => {
  new FacetsToggle();
});
